module.exports = __webpack_public_path__ + "static/media/network.bc995b77.svg";